export enum AttributeTypes {
    COLOR = "Color",
    GENERATION = "Generation",
    MOVEMENT_TYPE = "Movement Type",
    MOVEMENT_SPEED = "Movement Speed",
    COLOR_EFFECT = "Color Effect",
    SIZE = "Size",
};